function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.857 9h3.857M6.428 3.857h10.286M12.857 9h9M55.873 25.82H43.759a1.21 1.21 0 01-1.212-1.212v-4.846c0-.67.542-1.211 1.212-1.211h12.114c.67 0 1.211.541 1.211 1.211v4.846a1.21 1.21 0 01-1.211 1.211z",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.97 25.819v25.439a1.21 1.21 0 01-1.211 1.211h-9.691",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.145 52.47l-4.15-15.175a2.422 2.422 0 00-2.337-1.785h-14.42c-1.207 0-2.325.825-2.52 2.016a2.424 2.424 0 002.39 2.83h10.903M57.084 69.429c5.352 0 9.691-4.339 9.691-9.691s-4.339-9.691-9.69-9.691c-5.353 0-9.692 4.339-9.692 9.69 0 5.353 4.339 9.692 9.691 9.692zM60.718 59.738a3.634 3.634 0 11-3.634-3.635M30.434 59.738c0 5.352-4.34 9.69-9.691 9.69-5.352 0-9.691-4.338-9.691-9.69M42.548 24.608h-4.846a1.21 1.21 0 01-1.211-1.212v-2.422c0-.67.541-1.212 1.211-1.212h4.846",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.804 25.819c.946 8.177 13.76 12.114 13.76 20.593v8.63M47.393 59.738H24.43m-9.113-20.176a10.894 10.894 0 00-7.899 10.485v8.48c0 .67.542 1.21 1.212 1.21h3.585m6.429 0h-1.664M7.417 58.526c0-6.689 5.424-12.113 12.114-12.113",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.13 46.97a14.462 14.462 0 016.954-1.769c3.162 0 6.092 1.015 8.481 2.737",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.428 19.929v-3.786a2 2 0 012-2h19.143a2 2 0 012 2v16.572a2 2 0 01-2 2H8.428a2 2 0 01-2-2V29.57",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M11.571 30.857v-5.143M15.428 14.143v5.714a2 2 0 002 2h2.429a2 2 0 002-2v-5.714",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M44.344 13.157a10.71 10.71 0 017.311-7.535c5.674-1.685 11.639 1.549 13.324 7.222a10.71 10.71 0 01-2.37 10.29",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeDasharray: "0.5 5"
});

function SvgInDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "/img/in-delivery.svg";
export { SvgInDelivery as ReactComponent };